import { epicRequest, reduxFetchCreator, serverResponse } from 'app'

import type { ServerResponseSchema } from 'app'

import type { ImportTypes, StageSchema } from '../../schemas/StageSchema'

export type FetchAction = {
  importType: ImportTypes | string
  importUrl: string
} & Partial<StageSchema> &
  Pick<StageSchema, 'tournament_id'>

const fetch = reduxFetchCreator<'stageSave', FetchAction, ServerResponseSchema<StageSchema>>(
  'stageSave',
  serverResponse<StageSchema>(),
)

const stageSaveEpic = epicRequest({
  actionType: fetch.actions.stageSave.type,
  errorAction: fetch.actions.stageSaveError,
  // @todo fix type
  fulfilledAction: fetch.actions.stageSaveFulfilled,
  request: ({ payload }: { payload: FetchAction }) => ({
    body: { ...payload, _method: payload.id ? 'PUT' : 'POST' },
    method: 'post',
    url: `sports/soccer/stages${payload.id ? `/${payload.id}` : ''}`,
  }),
  // @ts-ignore
  untilTypes: fetch.actions.stageSaveCancel.type,
})

export const actions = {
  ...fetch.actions,
}

export const epics = [stageSaveEpic]

export const { reducer } = fetch
